// Copyright TraderEvolution Global LTD. © 2017-2024. All rights reserved.

import { Resources } from "../../Commons/properties/Resources.js";
import { QuickTableColumnType } from "../elements/QuickTable/QuickTableMisc.js";
import { BaseItem } from "./BaseItem.js";
import { ColumnParams } from "./ColumnParams.js";
import { ThemeManager } from "../misc/ThemeManager.js";
import { DateTimeUtils } from "../../Utils/Time/DateTimeUtils.js";


export let StatementItem = function (statement, sessionSettings)
{
    BaseItem.call(this, sessionSettings);

    this.statement = statement;

    let tm = ThemeManager.CurrentTheme;

    this.CellForeColorMap[1] = tm.TableGoldColor;
    this.CellForeColorMap[8] = tm.TableGoldColor;
}
StatementItem.prototype = Object.create(BaseItem.prototype);

StatementItem.prototype.ColumnCount = function ()
{
    return StatementItem.columnsParams.length;
}

StatementItem.prototype.getColumnData = function (column)
{
    let value = null;
    let formattedValue = null;

    if (this.statement === null)
    {
        value = null;
        formattedValue = "";
    }

    value = this.getColumnValue(column);

    switch (column)
    {
        case 2:
        case 10:
            formattedValue = isNaN(value.getTime()) ? Resources.getResource('general.N_A') : DateTimeUtils.formatDate(value, 'DD.MM.YYYY  HH:mm:ss');
            break;
            break;
        default:
            formattedValue = value ? value.toString() : ''
            break;
    }

    return { Value: value, FormattedValue: formattedValue };
}

StatementItem.prototype.getColumnValue = function (column)
{
    let statement = this.statement

    if (statement === null)
        return null;

    switch (column)
    {
        case 0:
            return statement.Account

        case 1:
            return statement.InstrumentStr;

        case 2:
            return statement.Date;

        case 3:
            return statement.OperationType;

        case 4:
            return statement.OperationID;

        case 5:
            return statement.Amount;

        case 6:
            return statement.OpenPrice;

        case 7:
            return statement.ClosePrice;

        case 8:
            return statement.Quantity;

        case 9:
            return statement.Currency;

        case 10:
            return statement.TradeOpeningDate;

        case 11:
            return statement.OpenCrossPrise;

        default:
            return null;
    }
}

StatementItem.prototype.GetCurrentAccount = function ()
{
    return this.statement !== null ? this.statement.Account : null
}

StatementItem.prototype.getFormatTotalValue = function (column, value, precisionMode = false)
{
    let formattedValue = "";

    switch (column)
    {
        case 5:
        case 8:
            if (precisionMode)
                return 2;
            formattedValue = value.toFixed(2)
            break;
    }

    return formattedValue;
}

StatementItem.prototype.GetColumnParams = function (column)
{
    let result = StatementItem.columnsParams[column];
    var isHidden = Resources.isHidden(result.HeaderKey);
    result.Hidden = isHidden;
    result.MenuIndex = this.GetMenuIndex(result.HeaderKey);

    return result;
}

/// <summary>
/// Здесь хранятся настройки колонок (один экземпляр на класс)
/// </summary>
StatementItem.columnsParams = [
/*0*/   new ColumnParams("panel.statement.Account", 75, 0, false, true, false),
    new ColumnParams("panel.statement.Instrument", 75, 0, false, true, false),
    new ColumnParams("panel.statement.Date", 75, 0, false, true, false),
    new ColumnParams("panel.statement.Operation_type", 75, 0, false, true, false),
    new ColumnParams("panel.statement.Operation_ID", 75, 0, false, true, false),
/*5*/   new ColumnParams("panel.statement.Amount", 75, 3, true, true, false),
    new ColumnParams("panel.statement.Open_price", 75, 3, false, true, false),
    new ColumnParams("panel.statement.Close_price", 75, 3, false, true, false),
    new ColumnParams("panel.statement.Quantity", 75, 3, true, true, false),
    new ColumnParams("panel.statement.Currency", 75, 0, false, true, false),
/*10*/  new ColumnParams("panel.statement.Trade_opening_date", 70, QuickTableColumnType.COL_DATE_SORT, false, true, false),
    new ColumnParams("panel.statement.FX_rate", 75, 3, false, true, false),
];

StatementItem.prototype.GetMenuIndex = function (headerKey)
{
    if (StatementItem.ListMenuIndex.Contains(headerKey))
        return StatementItem.ListMenuIndex.indexOf(headerKey);
    else
        return 1000;
}

StatementItem.ListMenuIndex =
    [
        "panel.statement.Account",
        "panel.statement.Instrument",
        "panel.statement.Date",
        "panel.statement.Operation_type",
        "panel.statement.Operation_ID",
        "panel.statement.Amount",
        "panel.statement.Open_price",
        "panel.statement.Close_price",
        "panel.statement.Quantity",
        "panel.statement.Currency",
        "panel.statement.Trade_opening_date",
        "panel.statement.FX_rate",
    ];